// eslint-disable-next-line import/no-extraneous-dependencies
import { initializeApp } from 'firebase/app';
// Importar enableIndexedDbPersistence
import { getFirestore, connectFirestoreEmulator, enableIndexedDbPersistence } from 'firebase/firestore';
import { getAuth, connectAuthEmulator } from 'firebase/auth';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID
};

console.log('Firebase Project ID:', process.env.REACT_APP_FIREBASE_PROJECT_ID);

// Inicializar app
const app = initializeApp(firebaseConfig);

// Inicializar servicios
const db = getFirestore(app);
const auth = getAuth(app);

// Siempre conectar a emuladores en desarrollo (sin verificar hostname)
if (window.location.hostname === 'localhost') {
  console.log('Conectando a emuladores de Firebase...');
  connectFirestoreEmulator(db, 'localhost', 8080);
  connectAuthEmulator(auth, 'http://localhost:9099', { disableWarnings: true });
}

// Verificar si ya hemos intentado habilitar la persistencia para evitar intentos repetidos
let persistenceEnabled = false;

// Intentar habilitar persistencia offline
if (!persistenceEnabled) {
  persistenceEnabled = true;
  try {
    enableIndexedDbPersistence(db)
      .then(() => {
        console.log('Firestore offline persistence enabled successfully.');
      })
      .catch((err) => {
        if (err.code === 'failed-precondition') {
          console.warn('Firestore offline persistence failed: Multiple tabs open? Persistence might be enabled in another tab.');
        } else if (err.code === 'unimplemented') {
          console.warn('Firestore offline persistence failed: Browser does not support offline persistence.');
        } else {
          console.error('Firestore offline persistence failed with error:', err);
        }
      });
  } catch (e) {
    console.error('An unexpected error occurred while trying to enable Firestore offline persistence:', e);
  }
}

export { db, auth };
